import React from 'react';
import { Icon } from '@scp/ui-shared/theme/icons';
import { color } from '@scp/ui-shared/theme/variables';
import { SwitchInputBase } from './SwitchInputBase';
export var RADIO_BUTTON_SIZE = 22;

function getIconColor(_ref) {
  var checked = _ref.checked,
      invalid = _ref.invalid;

  if (invalid) {
    return color.invalid;
  }

  if (checked) {
    return color.action;
  }

  return undefined;
}

export var RadioButton = function RadioButton(props) {
  return React.createElement(SwitchInputBase, Object.assign({}, props, {
    checkedIcon: React.createElement(Icon, {
      name: "radio-button-checked",
      color: getIconColor({
        checked: true,
        invalid: props.invalid
      })
    }),
    uncheckedIcon: React.createElement(Icon, {
      name: "radio-button-unchecked",
      color: getIconColor({
        invalid: props.invalid
      })
    }),
    type: "radio",
    size: RADIO_BUTTON_SIZE
  }));
};